// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.digital-win-title {
  font-size: 24px;
  line-height: normal;
  margin-bottom: 0;
}

.mobile-participate {
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/campaign/play/win/digital-win/digital-win.component.scss"],"names":[],"mappings":"AASA;EAEI,eAAA;EACA,mBAAA;EACA,gBAAA;AATJ;;AAYA;EACI,mBAAA;AATJ","sourcesContent":["@use '../../../../../../assets/styles/colors' as colors;\n@use '../../../../../../assets/styles/bootstrap-essentials';\n\n.reward-details {\n    h4 {\n       \n    }\n}\n\n.digital-win-title {\n  \n    font-size: 24px;\n    line-height: normal;\n    margin-bottom: 0;\n}\n\n.mobile-participate {\n    margin-bottom: 20px;\n}\n\n@include bootstrap-essentials.media-breakpoint-up(lg) {}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
